import axios, { AxiosRequestConfig } from 'axios';
import config from '../configuration/config';
import { getToken } from '../api/auth'; 

interface FetchApiParams {
    endpoint: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    params?: Record<string, any>;
    body?: Record<string, any>;
    useToken?: boolean;
}

const fetchApi = async ({
    endpoint,
    method = 'GET',
    params = {},
    body = {},
    useToken = true,
}: FetchApiParams) => {
    try {
        const storedToken = useToken ? getToken() : null;
        const token = storedToken ? `Bearer ${storedToken}` : undefined;

        const requestConfig: AxiosRequestConfig = {
            url: `${config.API_URL}${endpoint}`,
            method,
            headers: {
                'Content-Type': 'application/json',
                ...(token && { Authorization: token }),
            },
            params: method === 'GET' ? params : undefined,
            data: method !== 'GET' ? body : undefined,
        };

        const response = await axios(requestConfig);
        return response.data;
    } catch (error: any) {
        console.error(`❌ Error en fetchApi (${endpoint}):`, error);
        throw error;
    }
};

export default fetchApi;
